const columnBase = {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.625rem',
    display: 'flex',
    paddingRight: '4.5625rem',
    minWidth: '9.4375rem',
};

export const addressColumn = {
    ...columnBase,
};

export const addressColumnThin = {
    ...columnBase,
    fontWeight: 'normal',
};

export const divider = ({ theme: { colors } }) => ({
    backgroundColor: colors.lightGrey,
    width: '0.0625rem',
    height: '3.5rem',
    marginRight: '1.25rem',
});

export const columnLine = {
    display: 'block',
};

export const link = ({ theme }) => ({
    color: theme.colors.blue,
    cursor: 'pointer',
    borderBottom: `1px solid ${theme.colors.blue}`,

    transition: theme.transition,
    transitionProperty: 'color',

    ':hover': {
        color: theme.colors.fuchsia,
    },
});
